<script lang="ts">
	import { showingGame } from "$lib/stores";
	import { onMount } from "svelte";

	onMount(() => {
		showingGame.set(false);
	});
</script>

<div id="container">
	<h1>404 - Not Found</h1>
	<h2>Go back to the <a href="/">home</a> page</h2>
</div>

<style lang="scss">
	#container {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		width: 100%;
		height: calc(100vh - 6em);
		color: white;
		font-size: 2em;
		h2 {
			font-size: 1em;
		}
	}
</style>
